/* istanbul ignore file */
import React from 'react';

import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

import type { SpaceCreationDialogProps } from '../../types';

const LazySpaceCreationDialog = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'space-creation-dialog' */
        './SpaceCreationDialog'
    );

    return { default: resolved.SpaceCreationDialog };
});

export const SpaceCreationDialog = ({ isOpen, ...props }: SpaceCreationDialogProps) => (
    <DelayedSuspense isDialog shouldLoad={isOpen}>
        <LazySpaceCreationDialog isOpen={isOpen} {...props} />
    </DelayedSuspense>
);
